<div class="container">
  <h1>
    @if (meetingInfo?.MeetingName) {
      <span>
        {{ meetingInfo?.ProjectName }}
      </span>
    } @else {
      Project Name
    }
  </h1>
  <h3>
    @if (meetingInfo?.MeetingName) {
      <span> Register for {{ meetingInfo?.MeetingName }} </span>
    }
  </h3>

  <p role="alert">Thank you! You have successfully registered.</p>

  <div class="button-row">
    <button
      #nextAttendeeButton
      class="blue-button"
      (click)="onNextAttendee()"
      aria-label="Next attendee. Register the next attendee for the meeting."
    >
      Next Attendee
    </button>
  </div>
</div>
